import screenerConfig from 'screenerConfig';

export const VIEW_TAB_CONFIG = screenerConfig.viewTabConfig;

export const VIEW_TABS_BY_DISPLAY_TYPE = screenerConfig.viewTabsByDisplayType;
